import React, { useState } from 'react';
import { Mail, Users, FileText, Send, Save, Eye, Plus, X, Image, Link, Bold, Italic, List } from 'lucide-react';
export function NewCampaign() {
  const [campaignName, setCampaignName] = useState('');
  const [subject, setSubject] = useState('');
  const [recipients, setRecipients] = useState<string[]>([]);
  const [emailContent, setEmailContent] = useState('');
  return <div className="space-y-6" data-id="element-972">
      <div className="flex items-center justify-between" data-id="element-973">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-974">Nuova Campagna</h1>
        <div className="flex items-center gap-3" data-id="element-975">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-976">
            <Save className="w-4 h-4" data-id="element-977" />
            <span className="text-sm" data-id="element-978">Salva Bozza</span>
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors" data-id="element-979">
            <Send className="w-4 h-4" data-id="element-980" />
            <span className="text-sm" data-id="element-981">Invia Campagna</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-982">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-983">
          {/* Campaign Details */}
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-984">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-985">
              Dettagli Campagna
            </h2>
            <div className="space-y-4" data-id="element-986">
              <div data-id="element-987">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-988">
                  Nome Campagna
                </label>
                <input type="text" value={campaignName} onChange={e => setCampaignName(e.target.value)} placeholder="Es: Nuovi Immobili Retail - Gennaio 2024" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-989" />
              </div>
              <div data-id="element-990">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-991">
                  Oggetto Email
                </label>
                <input type="text" value={subject} onChange={e => setSubject(e.target.value)} placeholder="Es: Opportunità esclusive nel Quadrilatero" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-992" />
              </div>
            </div>
          </div>
          {/* Email Editor */}
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-993">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-994">
              Contenuto Email
            </h2>
            <div className="space-y-4" data-id="element-995">
              <div className="flex items-center gap-2 pb-3 border-b border-gray-200" data-id="element-996">
                <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-997">
                  <Bold className="w-4 h-4 text-gray-600" data-id="element-998" />
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-999">
                  <Italic className="w-4 h-4 text-gray-600" data-id="element-1000" />
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1001">
                  <List className="w-4 h-4 text-gray-600" data-id="element-1002" />
                </button>
                <div className="w-px h-6 bg-gray-300 mx-2" data-id="element-1003" />
                <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1004">
                  <Link className="w-4 h-4 text-gray-600" data-id="element-1005" />
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1006">
                  <Image className="w-4 h-4 text-gray-600" data-id="element-1007" />
                </button>
              </div>
              <textarea value={emailContent} onChange={e => setEmailContent(e.target.value)} placeholder="Scrivi il contenuto della tua email..." rows={12} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] resize-none" data-id="element-1008" />
            </div>
          </div>
        </div>
        {/* Sidebar */}
        <div className="space-y-6" data-id="element-1009">
          {/* Recipients */}
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1010">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1011">
              Destinatari
            </h2>
            <div className="space-y-4" data-id="element-1012">
              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-[#1388ad] hover:bg-[#1388ad]/5 transition-colors" data-id="element-1013">
                <Plus className="w-4 h-4" data-id="element-1014" />
                <span className="text-sm" data-id="element-1015">Seleziona Destinatari</span>
              </button>
              {recipients.length > 0 && <div className="space-y-2" data-id="element-1016">
                  {recipients.map((recipient, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1017">
                      <span className="text-sm text-gray-900" data-id="element-1018">{recipient}</span>
                      <button className="p-1 hover:bg-gray-200 rounded transition-colors" data-id="element-1019">
                        <X className="w-4 h-4 text-gray-500" data-id="element-1020" />
                      </button>
                    </div>)}
                </div>}
            </div>
          </div>
          {/* Preview */}
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1021">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1022">
              Anteprima
            </h2>
            <button className="w-full flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1023">
              <Eye className="w-4 h-4" data-id="element-1024" />
              <span className="text-sm" data-id="element-1025">Visualizza Anteprima</span>
            </button>
          </div>
          {/* Stats Preview */}
          <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1026">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1027">
              Riepilogo
            </h2>
            <div className="space-y-3" data-id="element-1028">
              <div className="flex items-center justify-between" data-id="element-1029">
                <span className="text-sm text-gray-600" data-id="element-1030">Destinatari</span>
                <span className="text-sm font-semibold text-gray-900" data-id="element-1031">
                  {recipients.length}
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-1032">
                <span className="text-sm text-gray-600" data-id="element-1033">Stato</span>
                <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800" data-id="element-1034">
                  Bozza
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}